<template>
  <b-row
    :responsive="false"
    class="account-info__another-account b-margin-top--medium"
  >
    <b-column :column="12">
      <b-autocomplete
        v-model:text="$state.bankSearch"
        v-model:selected="$state.bank"
        label="Banco"
        variant="outlined"
        block
        :items="banks"
        :multiselect="false"
        :internal-search="true"
        :chips="false"
        labelled-by="text"
        searched-by="text"
        keyed-by="value"
        not-found-text="Banco não encontrado"
        clear-button
        :rules="{
          required: true,
        }"
        @select="handleBankSelect"
        @input="handleBankSearchInput"
        @clear="handleBankClear"
        @blur="handleBankBlur"
      />
    </b-column>

    <b-column :column="8">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.agencia"
        label="Agência"
        variant="outlined"
        maxlength="4"
        :block="true"
        :rules="{
          required: true,
          onlyNumbers: true,
        }"
      />
    </b-column>

    <b-column :column="4">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.agenciaDV"
        label="DV (Opcional)"
        variant="outlined"
        maxlength="1"
        :block="true"
        :rules="{
          onlyNumbers: true,
          required: false
        }"
      />
    </b-column>

    <b-column :column="8">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.conta"
        label="Conta"
        variant="outlined"
        maxlength="10"
        :block="true"
        :rules="{
          required: true,
          onlyNumbers: true,
        }"
      />
    </b-column>

    <b-column :column="4">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.contaDV"
        label="DV"
        variant="outlined"
        maxlength="1"
        :block="true"
        :rules="{
          required: true,
          onlyNumbers: true,
        }"
      />
    </b-column>

    <b-column :column="12">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.documentNumber"
        label="CNPJ"
        variant="outlined"
        mask="cnpj"
        :block="true"
        :rules="{
          required: true,
          cnpj: true
        }"
      />
    </b-column>

    <b-column :column="12">
      <b-input
        v-model="$WalletSacarModalStore.saqueData.bankAccount.legalName"
        label="Nome Completo"
        variant="outlined"
        :block="true"
        :rules="{
          required: true,
        }"
      />
    </b-column>
  </b-row>
</template>

<script setup>
import { computed, reactive } from 'vue';
import { useWalletSacarModalStore } from '@stores/finances';

const $WalletSacarModalStore = useWalletSacarModalStore();

const banks = computed(() => $WalletSacarModalStore.banks);

const $state = reactive({
  bank: undefined,
  bankSearch: undefined,
});

const handleBankSelect = (bank) => {
  $WalletSacarModalStore.saqueData.bankAccount.bankCode = bank.value;
};

const handleBankSearchInput = () => {
  if (!$state.bank) return;
  $state.bank = undefined;
  $WalletSacarModalStore.saqueData.bankAccount.bankCode = undefined;
};

const handleBankClear = () => {
  $WalletSacarModalStore.saqueData.bankAccount.bankCode = undefined;
};

const handleBankBlur = () => {
  if ($state.bankSearch !== $state.bank?.text) {
    $state.bankSearch = $state.bank?.text;
  }
};
</script>
